const auditLog = {
  searchPlaceholder: "Search logs...",
  filters: "Filters",
  clearFilters: "Clear",
  refresh: "Refresh",
  source: "Source",
  actorType: "Actor Type",
  dateFrom: "From",
  dateTo: "To",
  allSources: "All Sources",
  systemLogs: "System",
  documentLogs: "Documents",
  allActors: "All Actors",
  actorUser: "User",
  actorSubmitter: "Submitter",
  actorSystem: "System",
  actorAutomation: "Automation",
  colTimestamp: "Time",
  colSource: "Source",
  colActor: "Actor",
  colAction: "Action",
  colTarget: "Target",
  noEntries: "No audit log entries found",
  showing: "Showing",
  of: "of",
  oldData: "Previous Value",
  newData: "New Value",
} as const;
export default auditLog;
